const yandexCounter = '48515414';

export function collectCounters() {
    // Google Tag Manager
    const tracker = window.ga && window.ga.getAll && window.ga.getAll()[0];
    const googleClientId = (tracker && tracker.get('clientId')) || '';

    // Roistat
    const roistatVisit = (window.roistat && window.roistat.getVisit()) || '';
    const roistatMarker = (window.roistat && window.roistat.getSource()) || 'Direct';

    // Yandex
    const yaCounter = window[`yaCounter${yandexCounter}`];
    const yandexClientId = (yaCounter && yaCounter.getClientID()) || '';

    return {
        googleClientId,
        yandexClientId,
        roistatVisit,
        roistatMarker,
    };
}
